import { colors } from 'bench-style-constants';
import styled from 'styled-components';

const ButtonLink = styled.button`
  background: transparent;
  border: 0 none;
  box-shadow: none;
  color: ${colors.water};
  // Choosing "pointer" because the only reason you're using a button is because it's clickable
  cursor: pointer;
  display: inline;
  // The font-size, font-weight, and line-height are set to the Text "medium" style
  font-size: 14px;
  font-weight: 300;
  line-height: 16px;
  margin: 0;
  outline: none;
  padding: 0;
  // This position property is overriding the style that causes the button to shift down when it's
  // being depressed by the mouse, which uses 'position: relative' and 'top'
  position: static;
  text-align: left;
  text-decoration: none;
  // This text-shadow property is overriding a style from the Angular stylesheet
  text-shadow: none;

  // For accessibility reasons, the unstyled button still has focus styles in case someone is
  // tabbing to it. If you don't want yours to have focus styles, then override this.
  &:focus {
    text-decoration: underline;
  }
`;

export default ButtonLink;
